var _style, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRedStarFilled(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 22 20",
    width: 22,
    height: 20,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Icon awesome-star-svg") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", null, "\n\t\t.s0 { fill: #dc4822;stroke: #d0cfd6 } \n\t")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Icon_awesome-star",
    className: "s0",
    d: "m9.9 0.7q0.3-0.2 0.6-0.2 0.4 0 0.6 0.2 0.3 0.2 0.5 0.5l2.4 4.8 5.5 0.8q0.3 0 0.6 0.2 0.2 0.3 0.4 0.6 0.1 0.3 0 0.6-0.1 0.3-0.3 0.6l-4 3.8 0.9 5.3q0.1 0.3 0 0.6-0.2 0.3-0.5 0.5-0.2 0.2-0.6 0.3-0.3 0-0.6-0.2l-4.9-2.5-4.9 2.5q-0.3 0.2-0.6 0.1-0.3 0-0.6-0.2-0.3-0.2-0.4-0.5-0.2-0.3-0.1-0.6l0.9-5.3-3.9-3.8q-0.3-0.3-0.3-0.6-0.1-0.3 0-0.6 0.1-0.3 0.3-0.6 0.3-0.2 0.6-0.2l5.5-0.8 2.4-4.8q0.2-0.3 0.5-0.5z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRedStarFilled);
export default __webpack_public_path__ + "static/media/red-star-filled.2d6aba7065a3c8d1d146493f6ca65796.svg";
export { ForwardRef as ReactComponent };